'use client';
/**
 * /advertise 맨 아래 «신청하기» — 상품을 미리 고르지 않고 /ads/buy 로 보낸다(출처 from= 유지 · 계측).
 * 서버 HTML 은 기본 출처(advertise_bottom), 브라우저에서 주소의 ?from= 을 이어 붙인다(BuyCta 와 같은 규칙). 모든 방문자 같은 HTML. ⛔ 금액 문구 없음.
 */
import { useEffect, useState } from 'react';
import { trackAdvertiseClick } from '@/components/ads/acq/track';

const FROM_RE = /^[a-z0-9_]{1,30}$/;
const href = (from: string) => `/ads/buy?from=${encodeURIComponent(from)}`;

export default function AdvertiseCta({ label, from, className }: { label: string; from: string; className?: string }) {
  const [h, setH] = useState(() => href(from));
  useEffect(() => {
    try {
      const f = new URLSearchParams(window.location.search).get('from');
      setH(href(f && FROM_RE.test(f) ? f : from));
    } catch { /* 주소 못 읽으면 기본 출처 그대로 */ }
  }, [from]);
  return (
    <a href={h} rel="nofollow" className={className} data-advertise-cta={from} onClick={() => trackAdvertiseClick(from)}>
      {label} →
    </a>
  );
}
